import colors from '@mathflat/common/style/colors'
import { observer } from 'mobx-react'

import { Icon } from '@/component/atoms/Icon'
import { RouteName } from '@/router'
import navigationUtils from '@/utils/navigationUtils'
import S from './HeaderUtil.style'
import Profile from './Profile'
import { Badge } from '@/component/atoms/Badge'
import commonRepo from '@/repository/common.repo'

const FEEDBACK_TALLY_URL = 'https://tally.so/r/xXNGDJ'

const openFeedbackForm = () => {
  window.open(
    `${RouteName.tallyEmbed}?url=${encodeURIComponent(FEEDBACK_TALLY_URL)}`,
    '_blank',
    'noopener,noreferrer',
  )
}

const HeaderUtil = () => {
  return (
    <div css={S.Wrap}>
      <button
        data-component="새로고침버튼"
        className="flex handler-button"
        onClick={() => navigationUtils.reload()}
      >
        <div className="icon__wrapper button__refresh">
          <Icon name="refresh" size={20} color={colors.gray.$700} />
        </div>
      </button>
      <button type="button" className="feedback-badge" onClick={openFeedbackForm}>
        <Badge backgroundColor="var(--Colors-Green-500)" radius="100" size="xs">
          피드백
        </Badge>
      </button>
      {commonRepo.permission.get.myinfo.access && (
        <div css={S.basic} data-component="유저페이지 이동">
          <Profile />
        </div>
      )}
    </div>
  )
}

export default observer(HeaderUtil)
